import { StackedCellValue } from './stacked-cell-value';
import { formatNumber } from '@/lib/formatUtils';
import CellFieldV2 from '../cell-field-v2';

type DvtFieldV2Props = {
  row: any;
  onCellValueChange?: (rowUuid: string, field: string, newValue: any) => void;
  disabled?: boolean;
  showConversionInEdit?: boolean;
};

export function DvtFieldV2({
  row,
  onCellValueChange,
  disabled = false,
  showConversionInEdit = false
}: DvtFieldV2Props) {
  if (!row.ma_vt_data || !row.ma_vt_data?.dvt_data) return null;

  const dvtOptions = [
    {
      value: row.ma_vt_data?.dvt,
      label: row.ma_vt_data?.dvt_data?.ten_dvt
    }
  ];
  const quyDoiOptions =
    row.ma_vt_data?.quy_doi_dvt_data?.map((item: any) => ({
      value: item.dvt,
      label: item.dvt_data?.ten_dvt
    })) || [];
  const options = [...dvtOptions, ...quyDoiOptions].filter(
    (option, index, array) => array.findIndex(item => String(item.value) === String(option.value)) === index
  );

  const selectedDvt = row.dvt || row.ma_vt_data?.dvt_nl || row.ma_vt_data?.dvt;
  const selectedQuyDoi = row.ma_vt_data?.quy_doi_dvt_data?.find((item: any) => item.dvt === selectedDvt);
  const selectedDvtLabel = options.find(option => option.value === selectedDvt)?.label || row.dvt_data?.ten_dvt || '';
  const heSo = selectedQuyDoi?.he_so;
  const secondaryText =
    selectedDvt !== row.ma_vt_data?.dvt && heSo ? `=${formatNumber(heSo)}(${row.ma_vt_data?.dvt_data?.ten_dvt})` : null;
  const isReadOnlyDisplay = disabled || !onCellValueChange;
  const shouldShowSecondaryInEdit = !isReadOnlyDisplay && showConversionInEdit && Boolean(secondaryText);

  return (
    <div
      className={
        shouldShowSecondaryInEdit
          ? 'flex min-h-0 w-full flex-col justify-center gap-0.5'
          : 'flex min-h-0 w-full items-center'
      }
    >
      {isReadOnlyDisplay ? (
        <StackedCellValue primary={selectedDvtLabel} secondary={secondaryText} />
      ) : (
        <>
          <CellFieldV2
            name='dvt'
            type='select'
            value={selectedDvt}
            inputClassName='border-none'
            options={options}
            onValueChange={newValue => onCellValueChange(row.uuid, 'dvt', newValue)}
            disabled={disabled}
          />
          {shouldShowSecondaryInEdit ? (
            <p className='truncate whitespace-nowrap text-right text-[10px] font-semibold leading-[14px] text-green-600'>
              {secondaryText}
            </p>
          ) : null}
        </>
      )}
    </div>
  );
}
